module.exports = __webpack_public_path__ + "img/workFlowYfj.d8e8c4ec.png";